export default __webpack_public_path__ + "static/media/WNLProto3.5f633bc8.png";